class APIS {
	apis() {
		return {
			approvedMsgsListing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get/template/message/agent'
			},
			completedCampaignsListing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/cost/template'
			},
			sendAgentTemplateText: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/template/message/text'
			}
		};
	}
}

export default new APIS();
